import React, { Component } from "react";
import styled from "styled-components";

export default class FieldScreenshotUpload extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.input.onChange(e.target.files[0]);
  }

  render() {
    const StyledFieldScreenshotUpload = styled.div`
      &.required .labelContent:after {
        color: #a94442;
        content: " *";
      }

      .inputGroup {
        position: relative;
      }

      .description {
        opacity: 0.6;
        font-size: 0.9em;
      }
    `;
    const { input, label, required, meta } = this.props;
    return (
      <StyledFieldScreenshotUpload
        className={`form-group${required ? " required" : ""}${
          meta.error && meta.touched ? " has-error" : ""
        }`}
      >
        <label htmlFor={input.name} className="col-sm-3">
          <span className="labelContent">{label}</span>
        </label>
        <div className="col-sm-9 inputGroup">
          <input
            type="file"
            accept=".jpg, .png, .jpeg"
            onChange={this.onChange}
          />
        </div>
      </StyledFieldScreenshotUpload>
    );
  }
}
